import { render, staticRenderFns } from "./AccountPayableForm.vue?vue&type=template&id=48ca31fe&"
import script from "./AccountPayableForm.vue?vue&type=script&lang=js&"
export * from "./AccountPayableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports